import Box from '@mui/material/Box';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';

const NavbarClock = () => {
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => setCurrentTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    return (
        <Box
            sx={{
                display: 'none',
                '@media (min-width:1024px)': { display: 'flex' },
                alignItems: 'center',
                fontSize: '0.875rem',
                fontWeight: 500,
                color: '#475569',
                bgcolor: '#f8fafc',
                px: '0.75rem',
                py: '0.375rem',
                borderRadius: '9999px',
                border: '1px solid #e2e8f0',
            }}
        >
            {format(currentTime, 'MMM d, h:mm a')}
        </Box>
    );
};

export default NavbarClock;
